jQuery(function ($) {

	/** Fijar arriba el header de calificación para las páginas de los artículos **/
	var single_header = $(".single-header");
	if(single_header.length) {
		// Get the offset position of the single header
		var offset = single_header.offset();
		var offsetTop = offset.top

		$(window).scroll(function() {
		  if (window.pageYOffset > offsetTop) {
		    $(single_header).addClass("fixed");
		    $(".single-content").css("padding-top", single_header.height()+"px")
		  } else {
		  	$(single_header).removeClass("fixed");
		  	$(".single-content").css("padding-top", "0px")
		  }
		})
	}
	/*******/

	$(".navbar-toggler").on("click", function() {
		$("#navbar").toggleClass("show");
	})
});